// import React, { useState, useEffect } from "react";
// import css from "./uthorListEditor.module.css";
// import {
//   getStorage,
//   ref,
//   getDownloadURL,
//   uploadBytesResumable,
//   deleteObject,
// } from "firebase/storage";
// import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";
// import { deleteDoc } from "firebase/firestore";

// const HeroListEditor = () => {
//   const storage = getStorage();
//   const [heroes, setHeroes] = useState([]);
//   const [selectedHero, setSelectedHero] = useState(null);
//   const [newImage, setNewImage] = useState(null);
//   const [updatedData, setUpdatedData] = useState({});
//   const [ageGroups, setAgeGroups] = useState([]); // Вікові групи з б
//   const [selectedAges, setSelectedAges] = useState([""]); // Масив вибраних вікових груп

//   const objList = [
//     { name: "Ім'я", transliter: "name" },
//     { name: "Вік", transliter: "age" },
//     { name: "Опис 1", transliter: "descOne" },
//     { name: "Опис 2", transliter: "descSecond" },
//     { name: "Автор", transliter: "autor" },
//     { name: "Книга", transliter: "book" },
//     { name: "Малий опис", transliter: "smallDesc" },
//     { name: "Опис в жовтому квадраті", transliter: "greenKvadrat" },
//     { name: "Автор про героя", transliter: "autorAboutHero" },
//     { name: "Історія створення", transliter: "history" },
//     { name: "Інтервю 1", transliter: "internOne" },
//     { name: "Інтервю 2", transliter: "internSecond" },
//     { name: "Відео (ID YouTube)", transliter: "video" },
//   ];

//   useEffect(() => {
//     const fetchHeroes = async () => {
//       const heroesCollection = collection(db, "hero");
//       const heroesSnapshot = await getDocs(heroesCollection);
//       const heroesData = heroesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setHeroes(heroesData);
//     };

//     const fetchAgeGroups = async () => {
//       const filtersSnapshot = await getDocs(collection(db, "filters"));
//       const filtersData = filtersSnapshot.docs.map((doc) => doc.data());
//       const ageFilter = filtersData.find(
//         (filter) => filter.transliter === "yearGroup"
//       );
//       if (ageFilter) {
//         setAgeGroups(ageFilter.list);
//       }
//     };

//     fetchHeroes();
//     fetchAgeGroups();
//   }, []);

//   const handleSelectHero = (hero) => {
//     setSelectedHero(hero);
//     setUpdatedData(hero);
//     setNewImage(null);

//     if (typeof hero.yearGroup === "string") {
//       setSelectedAges([hero.yearGroup]);
//     } else if (Array.isArray(hero.yearGroup)) {
//       setSelectedAges(hero.yearGroup);
//     } else {
//       setSelectedAges([""]);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdatedData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAgeChange = (index, event) => {
//     const updatedAges = [...selectedAges];
//     updatedAges[index] = event.target.value;
//     setSelectedAges(updatedAges);
//   };

//   const addAgeGroup = () => {
//     setSelectedAges([...selectedAges, ""]);
//   };

//   const removeAgeGroup = (index) => {
//     const updatedAges = selectedAges.filter((_, i) => i !== index);
//     setSelectedAges(updatedAges);
//   };

//   const handleUpdateHero = async () => {
//     if (!selectedHero) return;

//     try {
//       Swal.fire({
//         title: "Оновлення даних...",
//         text: "Будь ласка, зачекайте...",
//         allowOutsideClick: false,
//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       let updatedFields = { ...updatedData, yearGroup: selectedAges };

//       if (newImage) {
//         const oldImageUrl = selectedHero.foto;

//         if (oldImageUrl) {
//           try {
//             const oldImageRef = ref(storage, oldImageUrl);
//             await deleteObject(oldImageRef);
//           } catch (error) {
//             console.warn("Не вдалося видалити старе зображення:", error);
//           }
//         }

//         const imageRef = ref(storage, `heroes/${newImage.name}`);
//         const uploadTask = uploadBytesResumable(imageRef, newImage);

//         const imageUrl = await new Promise((resolve, reject) => {
//           uploadTask.on(
//             "state_changed",
//             () => {},
//             (error) => reject(error),
//             async () => {
//               const url = await getDownloadURL(uploadTask.snapshot.ref);
//               resolve(url);
//             }
//           );
//         });

//         updatedFields.foto = imageUrl;
//       }

//       const heroRef = doc(db, "hero", selectedHero.id);
//       await updateDoc(heroRef, updatedFields);

//       setHeroes((prevHeroes) =>
//         prevHeroes.map((hero) =>
//           hero.id === selectedHero.id ? { ...hero, ...updatedFields } : hero
//         )
//       );

//       Swal.fire({
//         title: "Успішно!",
//         text: "Героя оновлено",
//         icon: "success",
//         confirmButtonText: "OK",
//       });

//       setSelectedHero(null);
//       setNewImage(null);
//     } catch (error) {
//       Swal.fire({
//         title: "Помилка",
//         text: `Не вдалося оновити героя: ${error.message}`,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };
//   const handleDeleteHero = async (heroId) => {
//     const confirmResult = await Swal.fire({
//       title: "Ви впевнені?",
//       text: "Це дію неможливо скасувати!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Так, видалити!",
//       cancelButtonText: "Скасувати",
//     });

//     if (confirmResult.isConfirmed) {
//       try {
//         // Видалення документа з Firestore
//         await deleteDoc(doc(db, "hero", heroId));

//         // Видалення зі списку у UI
//         setHeroes((prevHeroes) =>
//           prevHeroes.filter((hero) => hero.id !== heroId)
//         );

//         // Очистити форму, якщо редагувався саме цей герой
//         if (selectedHero?.id === heroId) {
//           setSelectedHero(null);
//           setUpdatedData({});
//           setNewImage(null);
//         }

//         Swal.fire("Видалено!", "Героя успішно видалено.", "success");
//       } catch (error) {
//         Swal.fire(
//           "Помилка!",
//           `Не вдалося видалити героя: ${error.message}`,
//           "error"
//         );
//       }
//     }
//   };
//   return (
//     <div className={css.allWrapForHero}>
//       <h2>Список героїв</h2>
//       <ul className={css.ulHer}>
//         {heroes.map((hero) => (
//           <li key={hero.id} className={css.wrapAllPHL}>
//             <h3>{hero.name}</h3>
//             {hero.foto && (
//               <div className={css.wrapHeroF}>
//                 <img src={hero.foto} alt={`Author ${hero.name}`} />
//               </div>
//             )}
//             <button onClick={() => handleSelectHero(hero)}>
//               {selectedHero?.id === hero.id ? "Закрити" : "Редагувати"}
//             </button>
//           </li>
//         ))}
//       </ul>

//       {selectedHero && (
//         <div className={css.editForm}>
//           <h3>Редагування героя</h3>

//           {objList.map((el, index) => (
//             <div key={index}>
//               <label>{el.name}:</label>
//               <input
//                 type={el.transliter === "age" ? "number" : "text"}
//                 name={el.transliter}
//                 value={updatedData[el.transliter] || ""}
//                 onChange={handleInputChange}
//               />
//             </div>
//           ))}

//           {/* Вікові групи */}
//           <div className={css.wrapSmallList}>
//             <p className={css.paramBooks}>Вікові групи</p>
//             {selectedAges.map((age, index) => (
//               <div key={index} className={css.ageGroupWrapper}>
//                 <select
//                   className={css.customSelect}
//                   value={age}
//                   onChange={(event) => handleAgeChange(index, event)}
//                 >
//                   <option value="" disabled>
//                     Оберіть вікову групу
//                   </option>
//                   {ageGroups.map((group, idx) => (
//                     <option key={idx} value={group}>
//                       {group}
//                     </option>
//                   ))}
//                 </select>
//                 {index > 0 && (
//                   <button
//                     type="button"
//                     className={css.removeAgeButton}
//                     onClick={() => removeAgeGroup(index)}
//                   >
//                     Видалити
//                   </button>
//                 )}
//               </div>
//             ))}
//             <button
//               type="button"
//               className={css.addAgeButton}
//               onClick={addAgeGroup}
//             >
//               Додати ще вікову групу
//             </button>
//           </div>

//           {/* Завантаження нового фото */}
//           <label>Завантажити нове фото:</label>
//           <input type="file" onChange={(e) => setNewImage(e.target.files[0])} />
//           <button onClick={handleUpdateHero}>Зберегти зміни</button>
//           <button
//             type="button"
//             className={css.removeAgeButton}
//             style={{
//               marginTop: "10px",
//               backgroundColor: "#d9534f",
//               color: "#fff",
//             }}
//             onClick={() => handleDeleteHero(selectedHero.id)}
//           >
//             Видалити героя
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HeroListEditor;

import React, { useState, useEffect } from "react";
import css from "./uthorListEditor.module.css";
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import { deleteDoc } from "firebase/firestore";

const HeroListEditor = () => {
  const storage = getStorage();
  const [heroes, setHeroes] = useState([]);
  const [selectedHero, setSelectedHero] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [ageGroups, setAgeGroups] = useState([]); // Вікові групи з б
  const [selectedAges, setSelectedAges] = useState([""]); // Масив вибраних вікових груп

  const objList = [
    { name: "Ім'я", transliter: "name" },
    { name: "Вік", transliter: "age" },
    { name: "Опис 1", transliter: "descOne" },
    { name: "Опис 2", transliter: "descSecond" },
    { name: "Автор", transliter: "autor" },
    { name: "Книга", transliter: "book" },
    { name: "Малий опис", transliter: "smallDesc" },
    { name: "Опис в жовтому квадраті", transliter: "greenKvadrat" },
    { name: "Автор про героя", transliter: "autorAboutHero" },
    { name: "Історія створення", transliter: "history" },
    { name: "Інтервю 1", transliter: "internOne" },
    { name: "Інтервю 2", transliter: "internSecond" },
    { name: "Відео (ID YouTube)", transliter: "video" },
  ];

  useEffect(() => {
    const fetchHeroes = async () => {
      const heroesCollection = collection(db, "hero");
      const heroesSnapshot = await getDocs(heroesCollection);
      const heroesData = heroesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setHeroes(heroesData);
    };

    const fetchAgeGroups = async () => {
      const filtersSnapshot = await getDocs(collection(db, "filters"));
      const filtersData = filtersSnapshot.docs.map((doc) => doc.data());
      const ageFilter = filtersData.find(
        (filter) => filter.transliter === "yearGroup",
      );
      if (ageFilter) {
        setAgeGroups(ageFilter.list);
      }
    };

    fetchHeroes();
    fetchAgeGroups();
  }, []);

  const handleSelectHero = (hero) => {
    setSelectedHero(hero);

    setUpdatedData({
      ...hero,
      showOnSite: hero.showOnSite !== false,
    });

    setNewImage(null);

    if (typeof hero.yearGroup === "string") {
      setSelectedAges([hero.yearGroup]);
    } else if (Array.isArray(hero.yearGroup)) {
      setSelectedAges(hero.yearGroup);
    } else {
      setSelectedAges([""]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prev) => ({ ...prev, [name]: value }));
  };
  const handleVisibilityChange = (event) => {
    setUpdatedData((prev) => ({
      ...prev,
      showOnSite: event.target.checked,
    }));
  };
  const handleAgeChange = (index, event) => {
    const updatedAges = [...selectedAges];
    updatedAges[index] = event.target.value;
    setSelectedAges(updatedAges);
  };

  const addAgeGroup = () => {
    setSelectedAges([...selectedAges, ""]);
  };

  const removeAgeGroup = (index) => {
    const updatedAges = selectedAges.filter((_, i) => i !== index);
    setSelectedAges(updatedAges);
  };

  const handleUpdateHero = async () => {
    if (!selectedHero) return;

    try {
      Swal.fire({
        title: "Оновлення даних...",
        text: "Будь ласка, зачекайте...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let updatedFields = {
        ...updatedData,

        // Видаляємо порожні вікові групи
        yearGroup: selectedAges.filter((age) => age !== ""),

        // Старі документи без поля вважаємо видимими
        showOnSite: updatedData.showOnSite !== false,
      };
      if (newImage) {
        const oldImageUrl = selectedHero.foto;

        if (oldImageUrl) {
          try {
            const oldImageRef = ref(storage, oldImageUrl);
            await deleteObject(oldImageRef);
          } catch (error) {
            console.warn("Не вдалося видалити старе зображення:", error);
          }
        }

        const imageRef = ref(storage, `heroes/${newImage.name}`);
        const uploadTask = uploadBytesResumable(imageRef, newImage);

        const imageUrl = await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            () => {},
            (error) => reject(error),
            async () => {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(url);
            },
          );
        });

        updatedFields.foto = imageUrl;
      }

      const heroRef = doc(db, "hero", selectedHero.id);
      await updateDoc(heroRef, updatedFields);

      setHeroes((prevHeroes) =>
        prevHeroes.map((hero) =>
          hero.id === selectedHero.id ? { ...hero, ...updatedFields } : hero,
        ),
      );

      Swal.fire({
        title: "Успішно!",
        text: "Героя оновлено",
        icon: "success",
        confirmButtonText: "OK",
      });

      setSelectedHero(null);
      setNewImage(null);
    } catch (error) {
      Swal.fire({
        title: "Помилка",
        text: `Не вдалося оновити героя: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const handleDeleteHero = async (heroId) => {
    const confirmResult = await Swal.fire({
      title: "Ви впевнені?",
      text: "Це дію неможливо скасувати!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Так, видалити!",
      cancelButtonText: "Скасувати",
    });

    if (confirmResult.isConfirmed) {
      try {
        // Видалення документа з Firestore
        await deleteDoc(doc(db, "hero", heroId));

        // Видалення зі списку у UI
        setHeroes((prevHeroes) =>
          prevHeroes.filter((hero) => hero.id !== heroId),
        );

        // Очистити форму, якщо редагувався саме цей герой
        if (selectedHero?.id === heroId) {
          setSelectedHero(null);
          setUpdatedData({});
          setNewImage(null);
        }

        Swal.fire("Видалено!", "Героя успішно видалено.", "success");
      } catch (error) {
        Swal.fire(
          "Помилка!",
          `Не вдалося видалити героя: ${error.message}`,
          "error",
        );
      }
    }
  };
  return (
    <div className={css.allWrapForHero}>
      <h2>Список героїв</h2>
      <ul className={css.ulHer}>
        {heroes.map((hero) => (
          <li key={hero.id} className={css.wrapAllPHL}>
            <h3>{hero.name}</h3>
            <p
              style={{
                color: hero.showOnSite === false ? "#d9534f" : "#198754",
                fontWeight: "600",
              }}
            >
              {hero.showOnSite === false
                ? "Прихований на сайті"
                : "Відображається на сайті"}
            </p>
            {hero.foto && (
              <div className={css.wrapHeroF}>
                <img src={hero.foto} alt={`Author ${hero.name}`} />
              </div>
            )}
            <button onClick={() => handleSelectHero(hero)}>
              {selectedHero?.id === hero.id ? "Закрити" : "Редагувати"}
            </button>
          </li>
        ))}
      </ul>

      {selectedHero && (
        <div className={css.editForm}>
          <h3>Редагування героя</h3>

          {objList.map((el, index) => (
            <div key={index}>
              <label>{el.name}:</label>
              <input
                type={el.transliter === "age" ? "number" : "text"}
                name={el.transliter}
                value={updatedData[el.transliter] || ""}
                onChange={handleInputChange}
              />
            </div>
          ))}
          <div className={css.heroVisibilityBlock}>
            <label className={css.heroVisibilityLabel}>
              <input
                type="checkbox"
                checked={updatedData.showOnSite !== false}
                onChange={handleVisibilityChange}
              />

              <span>Відображати героя на сайті</span>
            </label>

            <p className={css.heroVisibilityDescription}>
              Якщо вимкнути цей параметр, герой не відображатиметься на сторінці
              героїв, а в картці товару не буде кнопки переходу на сторінку
              героя. Сам блок героя в товарі залишиться.
            </p>
          </div>
          {/* Вікові групи */}
          <div className={css.wrapSmallList}>
            <p className={css.paramBooks}>Вікові групи</p>
            {selectedAges.map((age, index) => (
              <div key={index} className={css.ageGroupWrapper}>
                <select
                  className={css.customSelect}
                  value={age}
                  onChange={(event) => handleAgeChange(index, event)}
                >
                  <option value="" disabled>
                    Оберіть вікову групу
                  </option>
                  {ageGroups.map((group, idx) => (
                    <option key={idx} value={group}>
                      {group}
                    </option>
                  ))}
                </select>
                {index > 0 && (
                  <button
                    type="button"
                    className={css.removeAgeButton}
                    onClick={() => removeAgeGroup(index)}
                  >
                    Видалити
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              className={css.addAgeButton}
              onClick={addAgeGroup}
            >
              Додати ще вікову групу
            </button>
          </div>

          {/* Завантаження нового фото */}
          <label>Завантажити нове фото:</label>
          <input type="file" onChange={(e) => setNewImage(e.target.files[0])} />
          <button onClick={handleUpdateHero}>Зберегти зміни</button>
          <button
            type="button"
            className={css.removeAgeButton}
            style={{
              marginTop: "10px",
              backgroundColor: "#d9534f",
              color: "#fff",
            }}
            onClick={() => handleDeleteHero(selectedHero.id)}
          >
            Видалити героя
          </button>
        </div>
      )}
    </div>
  );
};

export default HeroListEditor;
